var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgVisible)?_c('a-modal',{staticClass:"dialog",attrs:{"title":_vm.title,"width":_vm.width,"visible":_vm.imgVisible,"footer":null},on:{"cancel":_vm.cancel}},[_c('div',{staticClass:"viewImg"},[_c('img',{attrs:{"width":_vm.imgWidth,"src":_vm.previewImg,"alt":_vm.previewImg}}),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }